import "../css/main.css";
import { toggleHamburger } from "./toggleHamburger";
import { accordion } from "./accordion";
import { initializeViewport } from "./initializeViewport";
import { initSlider } from "./slider";
import { instructorFilter } from "./instructorFilter";
import { toggleVolume } from "./toggleVolume";
import { resumeBgVideo } from "./resumeBgVideo";
import { toggleModalCalendar } from "./toggleModalCalendar";
import { archiveSelect } from "./archiveSelect";
import { faqFilter } from "./faqFilter";
import { smoothScrollToHash, setupAnchorLinks } from "./smoothScroll";
import { headingAbout } from "./headingAbout";
import { scrollToSingleBody } from "./scrollToSingleBody";

const init = (fn) => {
  try {
    fn();
  } catch (e) {
    console.error(e);
  }
};

document.addEventListener("DOMContentLoaded", () => {
  init(() => toggleHamburger("js-hamburger", "js-spmenu", 1024));
  init(accordion);
  init(initializeViewport);
  init(initSlider);
  init(instructorFilter);
  init(toggleVolume);
  init(resumeBgVideo);
  init(() => toggleModalCalendar("js-button-calendar", "js-modal-calendar"));
  init(archiveSelect);
  init(faqFilter);
  init(setupAnchorLinks);
  init(smoothScrollToHash);
  init(headingAbout);
  init(scrollToSingleBody);
});
